<script setup lang="ts">
import { computed, inject } from 'vue';
import type { ComputedRef } from 'vue';
import type { UserRole } from 'src/types/User';
import { mdiEyeOutline } from '@quasar/extras/mdi-v7';

/**
 * Persistent strip shown to teachers inside course content: their walkthrough
 * runs on the real course engine, and this makes it unmistakable that what
 * they are doing is a preview, not student progress.
 */
const currentUserRole =
  inject<ComputedRef<UserRole | undefined>>('currentUserRole');

const isTeacher = computed(() => currentUserRole?.value === 'teacher');
</script>

<template>
  <q-banner
    v-if="isTeacher"
    dense
    class="teacher-preview-banner text-dark"
  >
    <template #avatar>
      <q-icon
        :name="mdiEyeOutline"
        size="20px"
      />
    </template>
    {{ $t('TEACHER_PREVIEW_BANNER') }}
  </q-banner>
</template>

<style scoped>
.teacher-preview-banner {
  background: linear-gradient(90deg, #ffe082, #ffd54f);
  border-radius: 8px;
}

.body--dark .teacher-preview-banner {
  background: linear-gradient(90deg, #6d5300, #7a5f00);
  color: #ffe082 !important;
}
</style>
